import { useState, useEffect, useRef } from "react";
import { Modal, Row, Col, Button, Spin, Progress } from "antd";
import { LoadingOutlined, HomeOutlined, WifiOutlined } from "@ant-design/icons";
import "react-aspect-ratio/aspect-ratio.css";
import "../../../style.css";
import "../styles.css";
import "../../../globalStyles.css";
import db from "../../../../database";
import { v4 as uuidv4 } from "uuid";
import { processSync } from "../../../Sync/syncData";
import kisokLogo from "../../../../assets/images/kioskLogo.svg";
import kioskBGI from "../../../../assets/images/kioskBGI.png";
import "./style.css";
import MobileComponent from "./MobileComponent";
import EmailComponent from "./EmailComponent";
import HomeComponent from "./HomeComponent";
import PaymentSelection from "./PaymentSelection";
import Login from "./Login";
import AdminComponent from "./AdminComponent";
import defaultImage from "../../../../assets/images/no-image.svg";
import Scrollbars from "react-custom-scrollbars";
import PrivacyPolicyContent from "../../../PrivacyPolicyContent";
import useSyncProgressStore from "../../../../stores/useSyncProgressStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import { clock } from "../../../../utils/clock";
import useAuthStore from "../../../../stores/useAuthStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import useSessionStore from "../../../../stores/useSessionStore";
import Logo from "../../../../assets/images/logo-without-bg.png";
import dayjs from "dayjs";
import leftLoading from "../../../../assets/images/opo.gif";

const Kiosk = (props) => {
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const {
    cart,
    setCart,
    deleteCart,
    deleteProduct,
    selectedProductInCart,
    selectedRowKeys,
    tillData,
    filterdParkedList,
    orderHistoryDetails,
    paymentModal,
    tillDataPaymentMethods,
    addCashFlag,
    setDisplayReturnOrderSearch,
    displayReturnOrderSearch,
    setKioskUI,
    kioskLogin,
    kioskUI,
    layoutType,
    setLayoutType,
    setIsInputFocused,
    isInputFocused,
    orderDelay,
  } = props;
  const { percent, promotionPercentage, productPercentage, productCategoryPercentage, resetProgress } = useSyncProgressStore();
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig?.themeJSON).length > 0 ? JSON.parse(posConfig?.themeJSON)?.layout3 : {};
  const isThemeLogo = themeJSON.logoURL;
  const logoURL = isThemeLogo ? themeJSON.logoURL : kisokLogo;
  const logoImg = themeJSON.logoImg ? themeJSON.logoImg : kisokLogo;
  const tagline = themeJSON.tagline ? themeJSON.tagline : "Delicious food at your fingertips. Fast, fresh, and always satisfying.";
  const [loading, setLoading] = useState(false);
  const [categoriesData, setCategoriesData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState("All");
  const [productsList, setProductsList] = useState([]);
  const [originalProductsList, setOriginalProductsList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [syncLoad, setSyncLoad] = useState(false);
  const [isOffline, setIsOffline] = useState(false);
  const [inputName, setInputName] = useState("default");
  const keyboardRef = useRef(null);
  const inputRef = useRef(null);
  const [layoutName, setLayoutName] = useState("default");
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [clock1, setClock1] = useState(clock());
  const tillDocumentSequence = useSessionStore.getState().documentSequence;
  const [showBsUnits, setShowBsUnits] = useState(false);
  const defaultCustomer = tillData.tillAccess.csBunit?.b2cCustomer;
  const [clickCount, setClickCount] = useState(0);

  const handleKeyboardInputs = (button) => {
    if (button === "{shift}" || button === "{caps}") setLayoutName("shift");
    if (button === "{default}" || button === "{small}") setLayoutName("default");
    if (button === "{numbers}") setLayoutName("numbers");
    if (button === "{number}") setLayoutName("number");
  };

  const [groupedProducts, setGroupedProducts] = useState([]);
  const [businessUnitName, setBusinessUnitName] = useState("");

  const loadProducts = () => {
    db.products
      .filter((product) => product.isactive == true)
      .toArray()
      .then((products) => {
        const currentTime = dayjs().format("HH:mm:ss");

        const filteredProducts = products.filter((product) => {
          const timeslot = product.cwrMenuTimeslot;
          if (!timeslot || (Array.isArray(timeslot) && timeslot.length === 0)) {
            return true;
          }
          const startTime = timeslot.startTime ? dayjs(timeslot.startTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss") : null;
          const endTime = timeslot.endTime ? dayjs(timeslot.endTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss") : null;
          if (!timeslot.startTime && !timeslot.endTime) {
            return true;
          }
          // return currentTime >= timeslot.startTime && currentTime <= timeslot.endTime;
          return currentTime >= startTime && currentTime <= endTime;
        });

        const grouped = filteredProducts.reduce((acc, product) => {
          const { csBunitId, bunitName, imageUrl } = product;

          if (!acc[csBunitId]) {
            acc[csBunitId] = {
              csBunitId,
              bunitName,
              imageUrl,
              products: [],
            };
          }

          acc[csBunitId].products.push(product);
          return acc;
        }, {});

        console.debug("grouped (with timeslot) -------->", grouped);
        setGroupedProducts(Object.values(grouped));
      })
      .catch((error) => console.error("Error fetching products:", error));
  };

  useEffect(() => {
    loadProducts();
  }, []);

  const onChange = (inputs) => {
    kioskLogin.setFieldsValue(inputs);
  };

  const [retrunSearchType, setReturnSearchType] = useState("orderNo");
  const [selectedReturnOrder, setSelectedReturnOrder] = useState({});

  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    if (productsList.length > 0) {
      localStorage.setItem("productsList", JSON.stringify(productsList));
    }
  }, [productsList]);

  useEffect(() => {
    const storedProducts = localStorage.getItem("productsList");
    if (storedProducts) {
      setProductsList(JSON.parse(storedProducts));
      setOriginalProductsList(JSON.parse(storedProducts));
    }
  }, []);

  useEffect(() => {
    const getDefaultSaleType = async () => {
      const saleData = await db.posSaletypes.toArray();
      const defaultSaleTypeRecord = saleData.find((record) => record.cwrSaletype?.isdefault === "Y");
      usePOSConfigStore.getState().setSaleTypeData(defaultSaleTypeRecord);
    };
    getDefaultSaleType();
  }, []);

  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long", // Full day name (e.g., Wednesday)
    day: "numeric", // Day of the month (e.g., 28)
    month: "long", // Full month name (e.g., June)
    year: "numeric", // Full year (e.g., 2023)
  })}`;

  const deleteReceipt = (param) => {
    let cartObj = {
      items: [],
      couponInput: [],
      advancePayment: 0,
      total: 0,
      tax: 0,
      discount: 0,
      paid: 0,
      change: 0,
      totalQty: 0,
      roundOff: 0,
      payments: [],
      redemptionPoints: 0,
      accumulationPoints: 0,
      creditAmount: 0,
      docType: "Invoice",
      sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
      referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
      giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
      couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
      customer: defaultCustomer,
      salesRepId: null,
      cardPaymentData: {},
      // documentno: `${tillData.tillAccess.cwrTill.prefix}${documentSequence + 1}`,
      documentno: param ? `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}` : `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
      // documentno: param ? `${tillData.tillAccess.cwrTill.prefix}${documentSequence + 1}` : `${tillData.tillAccess.cwrTill.prefix}${documentSequence + 1}`,
    };
    setCart(cartObj);
  };

  const handleOffline = () => {
    setIsOffline(true);
    Modal.warning({
      icon: null,
      centered: true,
      okButtonProps: { style: { display: "none" } },
      width: "32%",
      content: (
        <div
          style={{
            fontSize: "18px",
            fontWeight: "500",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: 0,
            fontSize: "1vw",
          }}
        >
          <div
            style={{
              backgroundColor: "#ffd6d9",
              borderRadius: "50%",
              width: "55px",
              height: "55px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              marginTop: "15px",
            }}
          >
            <WifiOutlined style={{ color: "#ff4d4f", fontSize: "28px" }} />
            <div
              style={{
                position: "absolute",
                width: "25px",
                height: "1.5px",
                backgroundColor: "#ff4d4f",
                transform: "rotate(50deg)",
              }}
            />
          </div>
          <p style={{ margin: "18px 0 0 0", fontSize: "1.8em", fontWeight: "500", color: "#0F0718" }}>Network Unavailable</p>
          <p style={{ color: "#0F0718", fontWeight: 400, fontSize: "1.25em", padding: "10px 20px 0 20px" }}>System is offline. Please check the connection before proceeding.</p>
        </div>
      ),
      style: {
        textAlign: "center",
        height: "50vh",
        width: "80%",
      },
      modalRender: (modal) => <div style={{ borderRadius: "10px", overflow: "hidden" }}>{modal}</div>,
      bodyStyle: {
        padding: "0",
      },
      closable: false,
      onOk: null,
    });
  };

  const handleOnline = () => {
    setIsOffline(false);
    Modal.destroyAll();
  };

  useEffect(() => {
    if (!navigator.onLine) {
      handleOffline();
    }

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  useEffect(() => {
    let syncOrdersInterval;
    const startSyncInterval = () => {
      syncOrdersInterval = setInterval(async () => {
        const currentCartObj = useCartStore.getState().cart;
        if (!currentCartObj) {
          return;
        }
        const lastUpdatedTimeString = dayjs(useSessionStore.getState().lastUpdatedTime).format("HH:mm:ss");
        const lastUpdatedTime = dayjs(lastUpdatedTimeString, "HH:mm:ss");
        const lastUpdatedOrder = dayjs(orderDelay).format("HH:mm:ss");
        const lastOrderTime = dayjs(lastUpdatedOrder, "HH:mm:ss");
        let cartObj = currentCartObj;
        const currentTime = dayjs();
        const syncTime = posConfig?.["Incremental Data Sync Frequency (In Minutes)"] || 15;
        const lastFullSyncTime = await db.dataSyncSummary.where("syncType").equals("Full Sync").reverse().sortBy("syncEndTime");
        const fullSync = posConfig?.["fullDataSyncFrequency"] || 360;
        const diffMinutes = currentTime.diff(lastUpdatedTime, "minutes");
        let lastUpdatedFullTimeString = dayjs(new Date()).format("HH:mm:ss");
        if (lastFullSyncTime?.length > 0) {
          lastUpdatedFullTimeString = dayjs(lastFullSyncTime[0]?.syncEndTime).format("HH:mm:ss");
        }
        const lastUpdatedFullTime = dayjs(lastUpdatedFullTimeString, "HH:mm:ss");
        const diffMinutesFullSync = currentTime.diff(lastUpdatedFullTime, "minutes");
        const diffSeconds = currentTime.diff(lastOrderTime, "seconds");
        if (cartObj.items?.length === 0 && diffMinutesFullSync >= fullSync) {
          useSessionStore.getState().setLastUpdatedTime(null);
          setSyncLoad(true);
          let tillData = useAuthStore.getState().tillData;
          setCart({ ...cart, customer: defaultCustomer });
          await processSync(tillData, "Full Sync");
          setSyncLoad(false);
          resetProgress();
        } else if (cartObj.items?.length === 0 && diffMinutes >= syncTime && diffSeconds >= 15) {
          clearInterval(syncOrdersInterval); // Clear the interval while syncing
          setSyncLoad(true);
          let tillData = useAuthStore.getState().tillData;
          setCart({ ...cartObj, customer: defaultCustomer });
          await processSync(tillData, "Incremental Sync");
          setSyncLoad(false);
          resetProgress();
        }
      }, 30000);
    };
    startSyncInterval();
    return () => {
      clearInterval(syncOrdersInterval);
    };
  }, []);

  const handleKey = (e) => {
    const { altKey, keyCode } = e;
    if (altKey && keyCode === 82) {
      if (posConfig?.showSalesReturn === "Y") {
        setDisplayReturnOrderSearch(true);
      }
    }
  };

  useEffect(() => {
    const run = async () => {
      setTimeout(() => {
        try {
          const cartDetails = useCartStore.getState().cart;
          if (cartDetails) {
            setCart(cartDetails);
          }
        } catch (error) {
          console.error("Error parsing cart details:", error);
        }
      }, 200);
    };
    run();
  }, []);

  useEffect(() => {
    let methods = [];
    tillDataPaymentMethods.map((item) => {
      if (item.name === "Cash" && posConfig?.enableCash === "Y") {
        methods.push(item);
      } else if (item.name === "Card" && posConfig?.enableCard === "Y") {
        methods.push(item);
      } else if (item.name !== "Cash" && item.name !== "Card") {
        methods.push(item);
      }
    });
    if (!useTransactionStore.getState().salesReturn) {
      useTransactionStore.getState().setSalesReturn("N");
    }
    setIsInputFocused(false);
    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, []);

  const returnBillSearchInputRef = useRef();
  useEffect(() => {
    if (displayReturnOrderSearch) {
      setTimeout(() => {
        returnBillSearchInputRef.current.focus();
      }, 100);
    }
  }, [retrunSearchType, displayReturnOrderSearch, kioskUI]);

  useEffect(() => {
    const run = async () => {
      filterdParkedList?.map((item, index) => {
        item.key = uuidv4().replace(/-/g, "").toUpperCase();
      });
    };
    run();
  }, [addCashFlag, paymentModal]);

  orderHistoryDetails.map((item) => {
    item.name = item.customer.name;
    item.status = item.isSynced === 1 ? "Success" : "Pending";
  });

  const removeProductModal = () => {
    if (selectedRowKeys.length > 0) {
      deleteProduct(selectedProductInCart);
    }
  };

  let kioskProps = {
    ...props,
    setKioskUI,
    layoutName,
    setLayoutName,
    onChange,
    handleKeyboardInputs,
    keyboardRef,
    inputName,
    inputRef,
    setInputName,
    removeProductModal,
    setIsInputFocused,
    isInputFocused,
    categoriesData,
    selectedCategoryId,
    setSelectedCategoryId,
    productsList,
    setProductsList,
    originalProductsList,
    setOriginalProductsList,
    selectedCategory,
    setSelectedCategory,
    isLocked,
    setIsLocked,
    syncLoad,
    setSyncLoad,
    deleteReceipt,
    groupedProducts,
    setGroupedProducts,
    businessUnitName,
    setBusinessUnitName,
    showBsUnits,
    setShowBsUnits,
  };

  const mainDivStyles = themeJSON.appBgImageURL
    ? {
        backgroundImage: `url(${themeJSON.appBgImageURL})`,
        backgroundPosition: "100% 100%",
        backgroundSize: "cover",
        backgroundColor: themeJSON.backgroundColor,
        height: "100vh",
        width: "100%",
      }
    : {
        backgroundImage: `url(${kioskBGI})`,
        backgroundSize: "cover",
        backgroundColor: themeJSON.backgroundColor,
        backgroundPosition: "10% 10%",
        height: "100vh",
        width: "100%",
        position: "absolute",
      };

  const styles = {
    container: {
      width: "100vw",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#f3f4f6",
    },
    header: {
      textAlign: "center",
      color: "#2F3856",
      fontSize: "3vh", // Responsive font size
      fontWeight: "500",
      padding: "2vh 0",
    },
    main: {
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: "2vw",
    },
    logoContainer: {
      width: "20vw",
      height: "20vw",
      maxWidth: "24vh",
      maxHeight: "24vh",
      border: "0.5vh solid #2F3856", // Border thickness in vh
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundImage: `url(${logoURL})`,
      backgroundPosition: "center",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
    },
    description: {
      color: "#2F3856",
      maxWidth: "60vw",
      marginTop: "1vh",
      fontSize: "2vh",
    },
    button: {
      height: "6vh",
      backgroundColor: themeJSON.orderNoTextColor,
      borderColor: "#2F3856",
      color: "white",
      fontSize: "2vh",
      padding: "1.5vh 3vw", // Scalable padding
      borderRadius: "50px",
    },
    footer: {
      width: "100%",
      backgroundColor: "#2F3856",
      padding: "2vh 0",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      color: "white",
      fontSize: "1.8vh",
    },
    footerText: {
      textAlign: "center",
      fontSize: "1.5vh",
      color: "#fff",
      padding: "1vh 0",
      backgroundColor: "#2F3856",
      width: "100%",
      border: "none",
    },
    footerIcon: {
      fontSize: "3vw", // Icons scale with viewport width
    },
  };

  const handleClick = () => {
    setClickCount((prev) => {
      const newCount = prev + 1;
      if (newCount === 3) {
        setIsLocked(true);
        setKioskUI(6);
        return 0; // Reset counter
      }
      return newCount;
    });

    // Reset count if no click within 1 second
    setTimeout(() => setClickCount(0), 1000);
  };

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#2F3856" }} spin />} spinning={loading}>
      {kioskUI === 0 ? (
        <>
          {syncLoad ? (
            <>
              <div style={{ backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%" }}>
                <Row style={{ height: "9vh", background: "", padding: "0.8% 0" }}>
                  <Col span={6}>
                    <img src={Logo} style={{ height: "2.8vw", paddingLeft: "1vw", paddingTop: "1vh" }} />
                  </Col>
                  <Col span={18} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingRight: "1vw", fontSize: "1vw" }}>
                    <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2em", color: "#0F0718" }}>{formattedDateTime}</div>
                    <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2em", color: "#0F0718" }}>{clock1}</div>
                  </Col>
                </Row>
                <div style={{ display: "flex", height: "90vh" }}>
                  <div
                    style={{
                      width: "48%",
                      background: "#fff",
                      height: "83vh",
                      margin: "1.5%",
                      marginRight: 0,
                      borderRadius: "10px",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "1vw" }}>
                      <div style={{ position: "relative", width: "13vw", height: "13vw" }}>
                        <img
                          src={leftLoading}
                          alt="Loading"
                          style={{
                            width: "100%",
                            height: "100%",
                            // transform: `rotate(${rotation}deg)`,
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            fontSize: "1.5em",
                            fontWeight: "500",
                            color: "#0F0718",
                          }}
                        >
                          {percent}
                        </div>
                      </div>
                      <p style={{ color: "#0F0718", fontFamily: "Inter", fontWeight: 500, fontSize: "2.5em", marginBottom: 0 }}>Till loading in process</p>
                    </div>
                  </div>
                  <div style={{ width: "48%", height: "83vh", background: "#fff", margin: "1.5%", borderRadius: "10px", color: "#0F0718" }}>
                    <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "17vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>
                      Product Categories
                    </p>
                    <Progress
                      strokeColor={{
                        from: "#2F3856",
                        to: "#2F3856",
                      }}
                      // showInfo={false}
                      style={{ padding: "0 2.5vw", fontSize: "1em", color: "#0F0718" }}
                      percent={productCategoryPercentage}
                      status="active"
                    />
                    <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "7vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>Products</p>
                    <Progress
                      strokeColor={{
                        from: "#2F3856",
                        to: "#2F3856",
                      }}
                      // showInfo={false}
                      style={{ padding: "0 2.5vw", fontSize: "1em", color: "#0F0718" }}
                      percent={productPercentage}
                      status="active"
                    />
                    <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "7vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>Promotions</p>
                    <Progress
                      strokeColor={{
                        from: "#2F3856",
                        to: "#2F3856",
                      }}
                      // showInfo={false}
                      style={{ padding: "0 2.5vw", fontSize: "1em", color: "#0F0718" }}
                      percent={promotionPercentage}
                      status="active"
                    />
                  </div>
                </div>
              </div>
            </>
          ) : isOffline ? (
            <p>You are currently offline. Please check your connection.</p>
          ) : showBsUnits && layoutType === 2 ? (
            <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", height: "100vh", overflow: "hidden" }}>
              <div style={{ flex: 1 }}>
                <div style={{ padding: "15px", fontSize: "1vw", overflow: "hidden" }}>
                  <div style={{ display: "flex", alignItems: "center", padding: "0px 10px 0px 10px", position: "relative" }}>
                    {/* <img src={logoURL} style={{ height: "5vw", width: "5vw" }} /> */}
                    <img
                      src={logoImg}
                      style={{
                        height: "4vh",
                        width: "auto",
                        maxWidth: "10vw",
                        objectFit: "contain",
                      }}
                      alt="Logo"
                    />
                    <p
                      style={{
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        color: "#0F0718",
                        fontSize: "2.7vh",
                        fontWeight: 500,
                        marginBottom: 0,
                        textAlign: "center",
                      }}
                    >
                      Select Counter
                    </p>
                  </div>
                  <Scrollbars style={{ height: "83vh", overflowX: "hidden" }}>
                    <div style={{ padding: "12px 10px 10px 10px" }}>
                      <Row gutter={[16, 16]} justify="start">
                        {groupedProducts.map((unit) => (
                          <Col xs={12} sm={12} md={12} lg={12} key={unit.csBunitId} style={{ display: "flex", justifyContent: "center" }}>
                            <div
                              style={{
                                padding: "15px",
                                border: "1px solid #ccc",
                                borderRadius: "7px",
                                cursor: "pointer",
                                width: "100%",
                                maxWidth: "750px",
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                                border: themeJSON.categoryBorder,
                              }}
                              onClick={async () => {
                                setKioskUI(3);
                                const customEvent = new CustomEvent("customStorageChange", {
                                  detail: { key: "kioskUI", newValue: 3 },
                                });
                                window.dispatchEvent(customEvent);
                                localStorage.setItem("kioskUI", 3);
                                setProductsList(unit.products);
                                setOriginalProductsList(unit.products);
                                setBusinessUnitName(unit.bunitName);
                                setSelectedCategoryId("All");
                                await db.productCategories.toArray().then((res) => {
                                  const mappedCategories = res.map((item) => ({
                                    ...item,
                                    label: item.value,
                                    value: item.mProductCategoryId,
                                  }));
                                  const matchedCategories = mappedCategories.filter((category) =>
                                    unit.products.some((product) => product.mProductCategoryId === category.mProductCategoryId)
                                  );

                                  const sortedCategories = matchedCategories.sort((a, b) => a.label.localeCompare(b.label));

                                  setCategoriesData(sortedCategories);
                                });
                              }}
                            >
                              <img src={unit?.imageUrl || defaultImage} style={{ height: "15vh" }} />
                              <p style={{ fontSize: "1.8vh", color: "#0F0718", fontWeight: 500, marginBottom: 0, marginTop: "10px" }}>{unit.bunitName}</p>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </Scrollbars>
                </div>
              </div>
              <footer
                style={{
                  backgroundColor: "#2F3856",
                  padding: "10px",
                  textAlign: "center",
                  width: "100%",
                  position: "relative",
                  bottom: 0,
                }}
              >
                <HomeOutlined
                  style={{ fontSize: "3vh", color: "#fff", cursor: "pointer" }}
                  onClick={() => {
                    if (cart.items.length > 0) {
                      Modal.confirm({
                        title: "This action will remove all products from the cart.Do you wish to proceed?",
                        icon: null,
                        cancelText: "No",
                        okText: "Yes",
                        centered: true,
                        autoFocusButton: null,
                        okButtonProps: { style: { display: "inline-block" } },
                        style: {
                          bottom: "50%",
                          transform: "translateY(-50%)",
                        },
                        onOk() {
                          deleteCart();
                          localStorage.setItem("kioskUI", 0);
                          setKioskUI(0);
                          const customEvent = new CustomEvent("customStorageChange", {
                            detail: { key: "kioskUI", newValue: 0 },
                          });
                          window.dispatchEvent(customEvent);

                          localStorage.setItem("layoutType", 0);
                          setLayoutType(0);
                          const customEvent1 = new CustomEvent("customStorageChange", {
                            detail: { key: "layoutType", newValue: 0 },
                          });
                          window.dispatchEvent(customEvent1);
                        },
                      });
                    } else {
                      localStorage.setItem("kioskUI", 0);
                      setKioskUI(0);
                      const customEvent = new CustomEvent("customStorageChange", {
                        detail: { key: "kioskUI", newValue: 0 },
                      });
                      window.dispatchEvent(customEvent);
                      localStorage.setItem("layoutType", 0);
                      setLayoutType(0);
                      const customEvent1 = new CustomEvent("customStorageChange", {
                        detail: { key: "layoutType", newValue: 0 },
                      });
                      window.dispatchEvent(customEvent1);
                    }
                  }}
                />
              </footer>
            </div>
          ) : (
            <div style={mainDivStyles}>
              <Modal open={isModalVisible} onCancel={() => setIsModalVisible(false)} footer={null} width={700}>
                <PrivacyPolicyContent />
              </Modal>
              <div style={styles.container}>
                {/* Header */}
                <header style={styles.header}>{tillData.tillAccess.csBunit.name}</header>

                {/* Main Content */}
                <main style={styles.main}>
                  <div style={styles.logoContainer} onClick={handleClick}>
                    {/* <span style={{ fontSize: "1.2vh", color: "#6b7280" }}>{tillData.tillAccess.csBunit.name}</span> */}
                  </div>
                  <h2 style={{ fontSize: "2vh", fontWeight: "600", marginTop: "16px" }}>Welcome to {tillData.tillAccess.csBunit.name}</h2>
                  {/* <p style={styles.description}>Delicious food at your fingertips. Fast, fresh, and always satisfying.</p> */}
                  <p style={styles.description}>{tagline}</p>
                  <Button
                    type="primary"
                    size="large"
                    style={styles.button}
                    onClick={() => {
                      loadProducts();
                      setShowBsUnits(true);
                      localStorage.setItem("kioskUI", 0);
                      setKioskUI(0);
                      const customEvent1 = new CustomEvent("customStorageChange", {
                        detail: { key: "kioskUI", newValue: 0 },
                      });
                      window.dispatchEvent(customEvent1);
                      localStorage.setItem("layoutType", 2);
                      setLayoutType(2);
                      const customEvent = new CustomEvent("customStorageChange", {
                        detail: { key: "layoutType", newValue: 2 },
                      });
                      window.dispatchEvent(customEvent);
                    }}
                  >
                    Start Order ➜
                  </Button>
                </main>
              </div>
            </div>
          )}
        </>
      ) : kioskUI === 1 ? (
        <MobileComponent {...kioskProps} />
      ) : kioskUI === 2 ? (
        <EmailComponent {...kioskProps} />
      ) : kioskUI === 3 ? (
        <HomeComponent {...kioskProps} productsList={productsList} setProductsList={setProductsList} />
      ) : kioskUI === 4 ? (
        <Login {...kioskProps} />
      ) : kioskUI === 5 ? (
        <PaymentSelection {...kioskProps} />
      ) : kioskUI === 6 ? (
        <AdminComponent {...kioskProps} />
      ) : null}
    </Spin>
  );
};

export default Kiosk;
